import * as React from "react";
import { SVGProps } from "react";

const SvgTwoDiamonds = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 285 398"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M273.7 0H11.9S.9.3.9 14.8v367.6c0 14.5 11 14.8 11 14.8h261.9s11-.3 11-14.8V14.8C284.7.3 273.7 0 273.7 0Z"
      fill="#fff"
    />
    <mask
      id="two-diamonds_svg__b"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={1}
      y={214}
      width={284}
      height={184}
    >
      <path
        d="M168.3 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168.3Z"
        fill="url(#two-diamonds_svg__a)"
      />
    </mask>
    <g mask="url(#two-diamonds_svg__b)">
      <path
        d="M168.3 214.4c-55.8 0-111.6 0-167.3.1v168c0 14.5 11 14.8 11 14.8h261.8s11-.3 11-14.8V214.4H168.3Z"
        fill="url(#two-diamonds_svg__c)"
      />
    </g>
    <mask
      id="two-diamonds_svg__e"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={285}
      height={199}
    >
      <path
        d="M.9 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.9S.9.3.9 14.8V198.2Z"
        fill="url(#two-diamonds_svg__d)"
      />
    </mask>
    <g mask="url(#two-diamonds_svg__e)">
      <path
        d="M.9 198.2c23.9 0 47.8 0 71.7.1 68.8 0 137.7 0 206.5.1h5.7V14.8c0-14.5-11-14.8-11-14.8H11.9S.9.3.9 14.8V198.2Z"
        fill="url(#two-diamonds_svg__f)"
      />
    </g>
    <mask
      id="two-diamonds_svg__h"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={6}
      y={0}
      width={279}
      height={398}
    >
      <path
        d="M284.1 14.8V382c0 14.5-11 14.8-11 14.8H11s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#two-diamonds_svg__g)"
      />
    </mask>
    <g mask="url(#two-diamonds_svg__h)">
      <path
        d="M284.1 14.8V382c0 14.5-11 14.8-11 14.8H11s-2.4-.1-4.9-1.6c2.8 2.1 5.8 2.2 5.8 2.2h261.9s11-.3 11-14.8V14.8c0-14.5-11-14.8-11-14.8h-.6c-.1 0 10.9.3 10.9 14.8Z"
        fill="url(#two-diamonds_svg__i)"
      />
    </g>
    <mask
      id="two-diamonds_svg__k"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={280}
      height={398}
    >
      <path
        d="M1.5 382.5V15.4C1.5.9 12.5.6 12.5.6h262.1s2.4.1 4.9 1.6C276.7.1 273.7 0 273.7 0H11.9S.9.3.9 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#two-diamonds_svg__j)"
      />
    </mask>
    <g mask="url(#two-diamonds_svg__k)">
      <path
        d="M1.5 382.5V15.4C1.5.9 12.5.6 12.5.6h262.1s2.4.1 4.9 1.6C276.7.1 273.7 0 273.7 0H11.9S.9.3.9 14.8v367.6c0 14.5 11 14.8 11 14.8h.6c0 .1-11-.2-11-14.7Z"
        fill="url(#two-diamonds_svg__l)"
      />
      <mask
        id="two-diamonds_svg__n"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={28}
        width={2}
        height={344}
      >
        <path
          d="M.9 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#two-diamonds_svg__m)"
        />
      </mask>
      <g mask="url(#two-diamonds_svg__n)">
        <path
          d="M.9 28.7v342.6l.6-2.1V34.9c-.2-2-.4-4.1-.6-6.2Z"
          fill="url(#two-diamonds_svg__o)"
        />
      </g>
    </g>
    <path
      d="M34.6 74.3c-7.2-4-12.9-16.1-13.1-16.4-.2.4-5.9 12.5-13.1 16.4 7.2 4 12.9 16.1 13.1 16.4.1-.3 5.9-12.4 13.1-16.4ZM25.3 47.6c.8 0 1.5 0 2-.1s.9-.3 1.2-.5c.3-.2.5-.5.7-.9.2-.4.4-1 .7-1.7H32l-.4 7.3H11v-1.2c.7-1.8 1.7-3.6 2.9-5.4 1.2-1.8 3-4 5.2-6.5 1.9-2.1 3.3-3.8 4.2-4.9.9-1.2 1.6-2.2 2.1-3.1.5-.9.8-1.7 1-2.5.2-.8.3-1.6.3-2.3 0-1.3-.2-2.4-.6-3.3-.4-1-1-1.7-1.8-2.3-.8-.6-1.9-.8-3.1-.8-3.1 0-5.2 1.7-6.3 5.2h-3v-4.8c2-1 3.9-1.6 5.7-2.1 1.8-.4 3.4-.6 4.8-.6 3.1 0 5.5.7 7.1 2 1.6 1.4 2.4 3.3 2.4 5.9 0 .9-.1 1.7-.3 2.4-.2.7-.5 1.5-.8 2.2-.4.7-.9 1.5-1.5 2.3-.6.8-1.3 1.7-2.1 2.5-.8.9-2.1 2.3-4 4.3-3.2 3.4-5.5 6.3-7 8.8h9.1v.1ZM248.1 322.2c7.2 4 12.9 16.1 13.1 16.4.2-.4 5.9-12.5 13.1-16.4-7.2-4-12.9-16.1-13.1-16.4-.1.3-5.9 12.4-13.1 16.4ZM257.4 348.8c-.8 0-1.5 0-2 .2-.5.1-.9.3-1.2.5-.3.2-.5.5-.7.9-.2.4-.4 1-.7 1.7h-2.1l.4-7.3h20.6v1.2c-.7 1.8-1.7 3.6-2.9 5.4-1.2 1.8-3 4-5.2 6.5-1.9 2.1-3.3 3.8-4.2 4.9-.9 1.2-1.6 2.2-2.1 3.1-.5.9-.8 1.7-1 2.5-.2.8-.3 1.6-.3 2.3 0 1.3.2 2.4.6 3.3.4 1 1 1.7 1.8 2.3.8.6 1.9.8 3.1.8 3.1 0 5.2-1.7 6.3-5.2h3v4.8c-2 1-3.9 1.6-5.7 2.1-1.8.4-3.4.6-4.8.6-3.1 0-5.5-.7-7.1-2-1.6-1.4-2.4-3.3-2.4-5.9 0-.9.1-1.7.3-2.4.2-.7.5-1.5.8-2.2.4-.7.9-1.5 1.5-2.3.6-.8 1.3-1.7 2.1-2.5.8-.9 2.1-2.3 4-4.3 3.2-3.4 5.5-6.3 7-8.8h-9.1v-.2ZM168.9 317.8c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6ZM168.9 79.5c-14.3-7.9-25.7-31.9-26-32.6-.4.8-11.8 24.7-26 32.6 14.2 7.9 25.7 31.9 26 32.6.3-.7 11.7-24.7 26-32.6Z"
      fill="#FF2601"
    />
    <defs>
      <radialGradient
        id="two-diamonds_svg__a"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.423 -135.451) scale(574.543)"
      >
        <stop offset={0.616} />
        <stop offset={0.752} stopColor="#020202" />
        <stop offset={0.804} stopColor="#090909" />
        <stop offset={0.841} stopColor="#151515" />
        <stop offset={0.872} stopColor="#262626" />
        <stop offset={0.899} stopColor="#3C3C3C" />
        <stop offset={0.922} stopColor="#585858" />
        <stop offset={0.944} stopColor="#797979" />
        <stop offset={0.963} stopColor="#9F9F9F" />
        <stop offset={0.982} stopColor="#CBCBCB" />
        <stop offset={0.998} stopColor="#F9F9F9" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__c"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(138.423 -135.451) scale(574.543)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.788} stopColor="#FDFDFD" />
        <stop offset={0.854} stopColor="#F6F6F6" />
        <stop offset={0.901} stopColor="#EAEAEA" />
        <stop offset={0.94} stopColor="#D9D9D9" />
        <stop offset={0.974} stopColor="#C3C3C3" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.108 366.656) scale(411.697)"
      >
        <stop offset={0.616} />
        <stop offset={0.71} stopColor="#020202" />
        <stop offset={0.762} stopColor="#0A0A0A" />
        <stop offset={0.805} stopColor="#181818" />
        <stop offset={0.842} stopColor="#2C2C2C" />
        <stop offset={0.875} stopColor="#464646" />
        <stop offset={0.906} stopColor="#656565" />
        <stop offset={0.935} stopColor="#8A8A8A" />
        <stop offset={0.963} stopColor="#B6B6B6" />
        <stop offset={0.988} stopColor="#E5E5E5" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(144.108 366.656) scale(411.697)"
      >
        <stop offset={0.616} stopColor="#fff" />
        <stop offset={0.747} stopColor="#FDFDFD" />
        <stop offset={0.821} stopColor="#F5F5F5" />
        <stop offset={0.88} stopColor="#E7E7E7" />
        <stop offset={0.932} stopColor="#D3D3D3" />
        <stop offset={0.978} stopColor="#BABABA" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__g"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.228 -.179) scale(457.129)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__i"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(-11.228 -.179) scale(457.129)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__j"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.433 115.635) scale(389.351)"
      >
        <stop />
        <stop offset={0.007} stopColor="#090909" />
        <stop offset={0.048} stopColor="#373737" />
        <stop offset={0.093} stopColor="#626262" />
        <stop offset={0.142} stopColor="#888" />
        <stop offset={0.195} stopColor="#A8A8A8" />
        <stop offset={0.254} stopColor="#C4C4C4" />
        <stop offset={0.32} stopColor="#DADADA" />
        <stop offset={0.397} stopColor="#EBEBEB" />
        <stop offset={0.493} stopColor="#F6F6F6" />
        <stop offset={0.627} stopColor="#FDFDFD" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__l"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(78.433 115.635) scale(389.351)"
      >
        <stop stopColor="#fff" />
        <stop offset={0.141} stopColor="#fff" />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__m"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.929 0 0 -456.924 296.507 -.18)"
      >
        <stop offset={0.099} />
        <stop offset={1} stopColor="#fff" />
      </radialGradient>
      <radialGradient
        id="two-diamonds_svg__o"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(-456.929 0 0 -456.924 296.507 -.18)"
      >
        <stop offset={0.099} stopColor="#fff" />
        <stop offset={1} stopColor="#ABABAB" />
      </radialGradient>
    </defs>
  </svg>
);

export default SvgTwoDiamonds;
